<template>
  <div class="zaym23">
    <checker-offers-block :offers="checkerDisplayOffers" />
    <div class="showcase-wrapper" :class="{ 'showcase-wrapper--no-swiper': !isSwiperEnabled }">
      <!-- Прогресс-полоса — ВЕРХ (только МОБИЛКА) -->
      <div v-if="isSwiperEnabled" class="swiper-pagination" ref="pagination"></div>
      <div v-if="isSwiperEnabled" class="swiper-text__label">Листайте влево</div>
      <div class="swiper showcase-swiper" ref="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
            <div class="card">

            
           
              <div class="card-rating">
                <span class="card-rating__star">★</span>
                <span class="card-rating__value">{{ offer.rating }}</span>
              </div>
              <div class="card-top">
                <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
              </div>

              <div class="card-info">
                <div class="card-info__wrapper">
                  <div class="card-info__img">
                    <img src="/img/zaym23sum.png" alt="">
                  </div>
                  <div class="card-info__value">до {{ numberFormat(offer.amount) }} ₽</div>
                </div>
                <div class="card-info__wrapper">
                  <div class="card-info__img">
                    <img src="/img/zaym23period.png" alt="">
                  </div>
                  <div class="card-info__value">до {{ offer.period }} дней</div>
                </div>
                <div class="card-info__wrapper">
                  <div class="card-info__img">
                    <img src="/img/zaym23percent.png" alt="">
                  </div>
                  <div class="card-info__value">без % - <span v-if="offer.without_percent">да</span>
                    <span v-if="!offer.without_percent">нет</span>
                  </div>
                </div>
              </div>

              <!-- Кнопка -->
              <div class="card-btn" @click="openLinks(offer)">
                <button type="button">ПОЛУЧИТЬ ЗАЕМ</button>
              </div>
            </div>
          </div>
        </div>

        <!-- СТРЕЛКИ — ТОЛЬКО МОБИЛКА -->
        <button v-if="isSwiperEnabled" class="showcase-nav prev" ref="prevBtn"
          :class="{ hidden: !hasMovedFromFirst }">‹</button>
        <button v-if="isSwiperEnabled" class="showcase-nav next" ref="nextBtn">›</button>

      </div>
    </div>

  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import * as Data from "../assets/js/data_params.js";
import StarRating from "@/components/StarRating";

import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
import CheckerOffersBlock from "./CheckerOffersBlock.vue";

export default {
  name: "Showcase23zaym.vue",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: { StarRating, CheckerOffersBlock },

  props: {
    offers: Array,
    checkerOffers: Array,
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return this.getCheckerDisplayOffers();
    },

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },

  },

  methods: {

    numberFormat(n) { return Functions.numberFormat(n); },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      (offer.links || []).forEach((l) => window.open(l, "_blank"));
    }
  }
};
</script>
<style lang="css">
@import url(../assets/css/zaym23.scss);
</style>
<style lang="css">
.star-rating {
  width: 50%;
}

.ozzaym .card-info__wrapper {

  display: flex;
  align-items: center;

}

.card-info__rate {
  margin-left: 30px;
  margin-bottom: 15px;
  width: 100%;
}

.swiper-text__label {
  display: none;
}

@media (max-width: 768px) {
  .swiper-text__label {
    display: block;
    font-weight: 400;
    font-size: 16px;
  }

  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

/* ===========================
   ДЕСКТОП (старый вид, без свайпера)
   =========================== */

@media (min-width: 768px) {

  /* полосы и стрелки вообще не показываем */
  .showcase-wrapper>.swiper-pagination,
  .showcase-nav {
    display: none !important;
  }

  .zaym23 .showcase-wrapper--no-swiper .showcase-swiper {
    overflow: visible;
  }

  .zaym23 .showcase-wrapper--no-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: flex-start;
  }

  .zaym23 .showcase-wrapper--no-swiper .swiper-slide {
    flex: 0 0 355px;
    max-width: 355px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .zaym23 .showcase-wrapper--no-swiper .card {
    width: 100%;
    max-width: 355px;
    box-sizing: border-box;
  }

  /* обычная сетка карточек */
  .zaym23 .showcase-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: flex-start;
    /* или center, если хочешь по центру */
  }

  .zaym23 .showcase-swiper .swiper-slide {
    flex: 0 0 355px;
    /* ЖЁСТКАЯ ширина колонки */
    max-width: 355px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .zaym23 .showcase-swiper .card {
    width: 100%;
    max-width: 355px;
    box-sizing: border-box;
  }
}

/* ===========================
   МОБИЛКА (Swiper + прогресс + стрелки)
   =========================== */
@media (max-width: 767px) {

  .showcase-wrapper {
    padding: 0 0 20px;
  }

  .zaym23 .showcase-wrapper--no-swiper {
    padding: 0;
  }

  .zaym23 .showcase-wrapper--no-swiper .showcase-swiper {
    overflow: visible;
  }

  .zaym23 .showcase-wrapper--no-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: center;
    transform: none !important;
  }

  .zaym23 .showcase-wrapper--no-swiper .swiper-slide {
    flex: 0 0 310px;
    max-width: 310px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .zaym23 .showcase-wrapper--no-swiper .card {
    max-width: 310px;
    width: 100%;
  }

  /* ПРОГРЕССБАР СВЕРХУ */
  .zaym23 .showcase-wrapper>.swiper-pagination {
    display: block;
    position: relative;
    max-width: 310px;
    /* как карточка */
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    /* ЦЕНТРИРУЕМ */
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .zaym23 .showcase-wrapper>.swiper-pagination .swiper-pagination-progressbar-fill {
    background: #FF9234;
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .showcase-swiper {
    overflow: visible;
    /* чтобы стрелки не обрезались */
    position: relative;
  }

  .zaym23 .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-slide .card {
    max-width: 310px;
    width: 100%;
  }

  /* СТРЕЛКИ */
  .zaym23 .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #000;
    background: #FF9234;
    border-radius: 50%;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .showcase-nav.prev {
    left: 0px;
  }

  .showcase-nav.next {
    right: 0px;
  }
}

@media (max-width: 430px) {
  .zaym23 .showcase-wrapper {
    flex-direction: row;
  }

  .zaym23 .showcase-wrapper--no-swiper .card {
    max-width: 310px !important;
    width: 100% !important;
  }
}
</style>
